import { randoms } from "."


interface DisputeBasicProps {
  Id?:number
  title:string
  usage:string
  design?:string
  layout?:string
  client?:string|null
  rp?:string|null
  subdomain?:string|null
  derived_from?:string|null
  generator?:string
}

interface BuildDisputeProps extends DisputeBasicProps {
  statements?:any[]
  evidence?:any[]
  [key:string]:any
}

const disputeBasicProps:DisputeBasicProps = {
  Id: 0, 
  title: "New Dispute", 
  usage: "generic", 
  client: null,
  rp: null,
  subdomain: null,
  derived_from: null,
  design: "Def Leppard",
  layout: "Nirvana",
  generator: "tb3"
}



export const build_new_statement = () => ({
  refstr: randoms.string(12,"a#"),
  title: "New Statement",
  description: "",
  visible: true,
  parent: [
    "[root]"
  ],
  parentResult: "any",
  level: 1,
  if_passes: "content",
  if_fails: "nothing",
  nested: {
    if_passes: null,
    if_fails: null
  },
  conditional: null,
  content: {
    pass: "Place your content here.",
    fail: null
  }
})

export const build_dispute_basic = ({...disputeBasicProps}:DisputeBasicProps) => ({
  Id: disputeBasicProps.Id,
  status: "draft",
  type: "template",
  generator: disputeBasicProps.generator,
  client: disputeBasicProps.client,
  subdomain: disputeBasicProps.subdomain || null,
  rp: disputeBasicProps.rp || null,
  title: disputeBasicProps.title,
  template_type: "suggested",
  derived_from: disputeBasicProps.derived_from || null,
  source: "original",
  design: disputeBasicProps.design,
  layout: disputeBasicProps.layout,
  usage: disputeBasicProps.usage,
  settings: {
    presets: [],
    tags: [],
    plugins: [],
  },
  notes: []
})

export const build_default_structure = () => [
  {
    type: "element",
    refstr: "topbar",
    seq: 1,
    level: 1,
    parent: null,
    height: "xs"
  },
  {
    type: "hstack",
    refstr: "header",
    seq: 2,
    level: 1,
    parent: null,
    split: [
      45,
      55
    ]
  },
  {
    type: "vstack",
    refstr: "header-left",
    seq: 1,
    level: 2,
    parent: "header",
    split: [
      100,
      100
    ]
  },
  {
    type: "element",
    refstr: "title_block",
    seq: 1,
    level: 3,
    parent: "header-left",
    height: "sm"
  },
  {
    type: "element",
    refstr: "summary_table",
    seq: 2,
    level: 3,
    parent: "header-left",
    height: "lg"
  },
  {
    type: "vstack",
    refstr: "header-right",
    seq: 2,
    level: 2,
    parent: "header",
    split: [
      100,
      100
    ]
  },
  {
    type: "element",
    refstr: "mm_logo",
    seq: 1,
    level: 3,
    parent: "header-right",
    height: "sm"
  },
  {
    type: "element",
    refstr: "summary_block",
    seq: 2,
    level: 3,
    parent: "header-right",
    height: "lg"
  },
  {
    type: "element",
    refstr: "letter_prefix",
    seq: 3,
    level: 1,
    parent: null,
    height: "sm"
  },
  {
    type: "element",
    refstr: "opening_statements",
    seq: 4,
    level: 1,
    parent: null,
    height: "md"
  },
  {
    type: "element",
    refstr: "trx_history",
    seq: 5,
    level: 1,
    parent: null,
    height: "sm"
  },
  {
    type: "element",
    refstr: "supporting_images",
    seq: 6,
    level: 1,
    parent: null,
    height: "lg"
  },
  {
    type: "element",
    refstr: "compelling_evidence",
    seq: 7,
    level: 1,
    parent: null,
    height: "lg"
  },
  {
    type: "element",
    refstr: "detail_screens",
    seq: 8,
    level: 1,
    parent: null,
    height: "lg"
  },
  {
    type: "element",
    refstr: "policies",
    seq: 9,
    level: 1,
    parent: null,
    height: "md"
  },
  {
    type: "element",
    refstr: "letter_closing",
    seq: 10,
    level: 1,
    parent: null,
    height: "sm"
  },
  {
    type: "element",
    refstr: "disclaimer",
    seq: 11,
    level: 1,
    parent: null,
    height: "sm"
  }
]

export const build_default_topbar = () => ({
  refstr: "topbar",
  rendertype: "dynamic",
  settings: {
    adminLabel: "Topbar",
    renderOption: "merchant_caseid"
  },
  "data": {}
})

export const build_default_title_block = () => ({
  refstr: "title_block",
  rendertype: "dynamic",
  settings: {
    adminLabel: "Topbar",
    displayTitle: "Dispute Evidence"
  },
  data: {}
})

export const build_default_logo_area = () => ({
  refstr: "mm_logo",
  rendertype: "static",
  settings: {
    adminLabel: "Logo Area",
    src: "https://acme.midmetrics.io/images/MM-Logo-Final-Black.svg"
  },
  data: {}
})

export const build_default_summary_table = () => ({
  refstr: "summary_table",
  rendertype: "dynamic",
  settings: {
    adminLabel: "Summary Table",
    renderOption: "standard_table_v1"
  },
  data: {}
})

export const build_default_summary_block = () => ({
  refstr: "summary_block",
  rendertype: "dynamic",
  settings: {
    adminLabel: "Summary Block",
    renderOption: "standard_block_v1"
  },
  data: {}
})

export const build_default_letter_prefix = () => ({
  refstr: "letter_prefix",
  rendertype: "dynamic",
  settings: {
    adminLabel: "Letter Prefix",
    renderOption: "standard_prefix_v1"
  },
  data: {}
})

export const build_opening_statements = (statements:any = []) => ({
  refstr: "opening_statements",
  rendertype: "dynamic",
  settings: {
    adminLabel: "Opening Statements",
    renderOption: "standard_op_statements_v1",
    config: statements
  },
  data: []
})

export const build_default_trx_history = () => ({
  refstr: "trx_history",
  rendertype: "dynamic",
  settings: {
    adminLabel: "Transaction History",
    sectionTitle: "Transaction History",
    renderOption: "standard_trx_history_v1"
  },
  data: {}
})

export const build_default_supporting_images = () => ({
  refstr: "supporting_images",
  rendertype: "dynamic",
  settings: {
    adminLabel: "Supporting Images",
    sectionTitle: "Supporting Images",
    renderOption: "standard_images_v1"
  },
  data: {}
})

export const build_compelling_evidence = (evidence:any[] = []) => ({
  refstr: "compelling_evidence",
  rendertype: "dynamic",
  settings: {
    adminLabel: "Compelling Evidence",
    sectionTitle: "Compelling Evidence",
    renderOption: "standard_evidence_v1",
    config: evidence
  },
  data: []
}) 

export const build_default_detail_screens = () => ({
  refstr: "detail_screens",
  rendertype: "dynamic",
  settings: {
    adminLabel: "Detail Screens",
    sectionTitle: "Transaction Details",
    renderOption: "standard_detail_screens_v1"
  },
  data: {}
})

export const build_default_policies = () => ({
  refstr: "policies",
  rendertype: "dynamic",
  settings: {
    adminLabel: "Policies",
    sectionTitle: "Policies",
    renderOption: "standard_policies_v1"
  },
  data: {}
})

export const build_default_letter_closing = () => ({
  refstr: "letter_closing",
  rendertype: "dynamic",
  settings: {
    adminLabel: "Letter Closing",
    renderOption: "standard_closing_v1"
  },
  data: {}
})

export const build_default_disclaimer = () => ({
  refstr: "disclaimer",
  rendertype: "dynamic",
  settings: {
    adminLabel: "Disclaimer",
    renderOption: "standard_disclaimer_v1"
  },
  data: {}
})

export const migrate_dispute = (original:any, statements:any[], evidence:any[]) => {
  return {
    Id: original.Id,
    title: original.Title,
    type: "template",
    template_type: original.TemplateType || "suggested",
    source: "original",
    status: "published",
    generator: original.generator,
    usage: "generic",
    client: null,
    subdomain: null,
    rp: null,
    derived_from: null,
    structure: [],
    elements: [
      build_default_topbar(),
      build_default_title_block(),
      build_default_logo_area(),
      build_default_summary_block(),
      build_default_summary_table(),
      build_default_letter_prefix(),
      build_opening_statements(statements),
      build_default_trx_history(),
      build_default_supporting_images(),
      build_compelling_evidence(evidence),
      build_default_detail_screens(),
      build_default_policies(),
      build_default_letter_closing(),
      build_default_disclaimer()
    ],
    design: "Def Leppard",
    layout: "Nirvana",
    settings: {
      presets: [],
      tags: [],
      plugins: [],
      notes: []
    }
  }
}

export const build_new_dispute = ({
  statements = [build_new_statement()],
  evidence = [build_new_statement()],
  ...disputeBasicProps
}:BuildDisputeProps) => ({
  ...build_dispute_basic({...disputeBasicProps}),
  structure: build_default_structure(),
  elements: [
    build_default_topbar(),
    build_default_title_block(),
    build_default_logo_area(),
    build_default_summary_table(),
    build_default_summary_block(),
    build_default_letter_prefix(),
    build_opening_statements(statements),
    build_default_trx_history(),
    build_default_supporting_images(),
    build_compelling_evidence(evidence),
    build_default_detail_screens(),
    build_default_policies(),
    build_default_letter_closing(),
    build_default_disclaimer()
  ]
})
